import { useHistory } from 'react-router-dom';

import { Autoplay, FreeMode, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../../utils/events';
import styles from "./homepageBanner.module.css";
import ImageBanner from './ImageBanner';
import ManualBanner from './ManualBanner';
import { BANNER_TYPES, HOMEPAGE_ROW_TYPE, RECIPE_OPEN_SOURCE, RECIPE_PATH_REGEX, URL_VALIDATE_REGEX } from './utils/constants';
import { BannerItem } from './utils/homepageJson.types';
import { autoplayConfig, freeModeConfig, paginationConfig } from './utils/swiperConfig';
import 'swiper/css';
import 'swiper/css/pagination';
import "./homepageBanner.css";

const HomepageBanner = ({ banners, uniqueKey, homePageRow, viewedHomePageRow }: { banners: BannerItem[], uniqueKey: string, homePageRow: number, viewedHomePageRow: number }) => {
  const history = useHistory();
  const { logRecipeEdit } = useLogRecipeEdit();

  const handleSlideClick = (banner: BannerItem, viewedHomePageColumn: number) => {
    logRecipeEdit(EventLogsEnum.APP_BANNER_OPENED, {
      eventData: { homePageRow, viewedHomePageRow, viewedHomePageColumn, bannerDetails: { ...banner } }
    })
    if (URL_VALIDATE_REGEX.test(banner.action)) window.open(banner.action, '_blank');
    else {
      if (RECIPE_PATH_REGEX.test(banner.action)) {
        logRecipeEdit(EventLogsEnum.APP_RECIPE_OPENED, {
          eventData: { homePageRow, viewedHomePageRow, viewedHomePageColumn, source: RECIPE_OPEN_SOURCE.HOMEPAGE, homePageRowType: HOMEPAGE_ROW_TYPE.BANNER }
        })
      }
      if (banner.type === 'manual' && banner.action.startsWith('/filter')) {
        history.push(`${banner.action}&title=${banner.manual.title}&source=banner`);
      }
      else {
        history.push(banner.action);
      }
    }
  };

  return (
    <div className={styles.banner_wrapper} id={`banner_container-${uniqueKey}`}>
      <Swiper
        autoplay={autoplayConfig}
        className="banner_swiper_container"
        freeMode={freeModeConfig}
        modules={[
          Pagination,
          Autoplay,
          FreeMode
        ]}
        pagination={paginationConfig}
        resistance
        resistanceRatio={0}
        slidesPerView='auto'
        spaceBetween={16}>
        {banners.map((banner: BannerItem, index: number) => (
          <SwiperSlide className="slide" key={banner.id} onClick={() => handleSlideClick(banner, index)}>
            {banner.type === BANNER_TYPES.MANUAL ? <ManualBanner manual={banner.manual} /> : null}
            {banner.type === BANNER_TYPES.IMAGE ? <ImageBanner imageUrl={banner.image} uniqueKey={banner.id} /> : null}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomepageBanner;
